// Keep server metadata authoritative; use local copy only for missing fields.
export function resolveSeoMetadata(server = {}, fallback = {}) {
  const result = { ...server }
  for (const key of ['title', 'keywords', 'describe_text']) {
    result[key] = typeof server?.[key] === 'string' && server[key].trim()
      ? server[key]
      : fallback[key] || ''
  }
  return result
}

export const japanesePalPortalMetadata = {
  title: 'JapanesePal Talk — Practice Brazilian & European Portuguese',
  describe_text: 'Start a real conversation in Brazilian or European Portuguese. Practice everyday situations with an AI tutor, pronunciation guidance and instant feedback on JapanesePal.',
  keywords: 'JapanesePal, Portuguese conversation practice, Brazilian Portuguese, European Portuguese, AI Portuguese tutor, Portuguese pronunciation, learn Portuguese speaking'
}
